import { isValidPassword } from "@wevideo/core/utils/PasswordUtils";

import { isProduction } from "./GeneralHelper";

export {
	PASSWORD_REQUIREMENTS,
	getPasswordRequirements,
	isValidPassword,
	validatePasswordComplexity,
} from "@wevideo/core/utils/PasswordUtils";

export { isValidEmail, isValidPhone } from "@wevideo/core/utils/FormValidation";

export const isValidPasswordForEnv = (password: string): boolean =>
	!isProduction() || isValidPassword(password);
